import React, { useEffect } from "react";
import "./style-rtl.scss";
import {
    hasItemPhoto,
    resolveBrandLogo,
    resolveItemPhotoUrl,
} from "../../brandAssets";

export default function Header({ photo, productName, logo }) {
    const banner = resolveItemPhotoUrl(photo);
    const brandLogo = resolveBrandLogo(logo);
    const compact = !hasItemPhoto(photo);

    useEffect(() => {
        const element = document.querySelector(".name-rate h2");
        const parentElement = document.querySelector(".name-rate");
        if (!element || !parentElement) return;
        if (
            element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth
        ) {
            parentElement.classList.add("overflow");
        }
    }, [productName]);

    return (
        <div className={`header-main${compact ? " header-main--compact" : ""}`}>
            <div
                className="middle-header"
                style={
                    banner
                        ? { backgroundImage: `url("${banner}")` }
                        : undefined
                }
            >
                <div className="name-rate">
                    <h2 className="product-name">{productName}</h2>
                </div>
                <div className="bottom-header">
                    <img src={brandLogo} alt="" />
                </div>
            </div>
        </div>
    );
}
